import React from 'react';

/* eslint-disable max-len,no-tabs,camelcase */
const Eyes_8 = ({ eyeColours, skinColours }) => {
  const colour0 = '#573D39';
  const colour1 = '#F15743';
  const colour2 = '#FFFEF0';
  const colour3 = '#F6E7D0';
  const colour4 = eyeColours.shadow;
  const colour5 = '#DF5656';
  const colour6 = skinColours.shadow;

  return (
    <>
      <g>
        <g>
          <g>
            <path
              fill={colour0}
              d="M473.3,402.5c2.8,0.4,18.8,5.2,18,4.6c-5.7-4.2-4.5-9.7-6.4-12.4c-4-5.5-7.2-6.2-7.2-6.2L473.3,402.5z"
            />
            <path
              fill={colour1}
              opacity={0.5}
              d="M424,400.4c-2.4-1.8-11.6-9.1-11.4-10.1c0.2-1,17.8-15.4,17.8-15.4L424,400.4z"
            />
            <path
              fill={colour1}
              opacity={0.5}
              d="M425,381.3c6.6-15.3,24.6-23.6,38.3-18c13.7,5.6,19.5,22.6,12.9,38c-6.6,15.3-23.1,23.1-36.8,17.5
				C425.6,413.1,418.4,396.6,425,381.3z"
            />
            <path
              fill={colour2}
              d="M428.6,381.7c6.4-14.8,21.8-22.6,34.3-17.4c12.6,5.2,17.5,21.3,11.2,36.1c-6.4,14.8-20.6,20-33.2,14.9
				C428.3,410.1,422.2,396.5,428.6,381.7z"
            />
            <path
              fill={colour3}
              d="M441.1,411.3c12.6,5.2,27.1-0.8,33.5-15.6c1-2.4,1.8-4.8,2.2-7.2c-0.2,3.9-1,7.9-2.7,11.9
				c-6.4,14.8-21,20.7-33.5,15.6c-10.7-4.4-16.4-15.4-14-27.7C426.2,398.7,431.8,407.5,441.1,411.3z"
            />
            <path
              fill={colour4}
              d="M441.6,382.8c2.9-5.7,9.6-8.3,14.9-5.7c5.3,2.6,7.3,9.4,4.4,15.1c-2.9,5.7-9.6,8.3-14.9,5.7
				C440.6,395.4,438.7,388.6,441.6,382.8z"
            />
            <path
              fill={colour5}
              opacity={0.5}
              d="M421.9,385.6c11.7-10.9,24.6-26.5,38.6-20.7c12.5,5.2,24,22.3,20.8,35.7
				C467.5,387.9,440.8,379.7,421.9,385.6z"
            />
            <path
              fill={colour2}
              d="M455.4,392.5c1.1-2.1,3.2-3.2,4.8-2.4c1.6,0.8,2,3.1,1,5.2c-1.1,2.1-3.2,3.2-4.8,2.4
				C454.8,396.9,454.4,394.6,455.4,392.5z"
            />
            <path
              fill={colour2}
              d="M459.1,387.8c-0.5-0.5-0.7-1.4-0.3-2.1c0.4-0.7,1.1-0.8,1.6-0.3c0.5,0.5,0.7,1.4,0.3,2.1
				C460.3,388.1,459.6,388.3,459.1,387.8z"
            />
            <path
              fill={colour6}
              d="M481.7,397.7c0.2-7.6-24.1-35.3-59.1-20.6c0,0,16.4-25.2,39.9-15.5C489.9,372.8,481.7,397.7,481.7,397.7z"
            />
            <path
              fill={colour6}
              d="M483.3,395c-0.7,3.5-1.3,5.1-1.3,5.1c0.3-7.9-21.3-33.4-66.3-13.8c0,0,5.9-7.8,7.6-10.4
				C455.6,364.3,478.5,384.4,483.3,395z"
            />
          </g>
          <path
            fill={colour0}
            d="M413,390.6c7.8-3,20.4-14.9,41.7-8.3c21.3,6.6,27.7,17.8,28.6,22c0,0,4-1.3,2.5-7.4
			c-1.6-6.1-13.8-18.7-30.9-20.6c-20.2-2.3-31,8.9-51.5,13.8L413,390.6z"
          />
          <path
            fill={colour6}
            d="M474.2,407.2c0,0-4.9,15.8-26,14.4c-16.2-1-29.9-20.1-32-28.8c0,0,19.2,17.6,36.1,17
			C469.3,409.3,474.2,407.2,474.2,407.2z"
          />
          <path
            fill={colour0}
            d="M405.5,390c17.1,2.2,25,26.1,50,23.7c25-2.4,19.6-7.9,38.9-4.7c0,0-11.6-7.9-20.1-5.8
			c-8.5,2.1-22.1,7.4-34.6,3.9C429.9,404.4,416.7,385.6,405.5,390z"
          />
          <path
            fill={colour0}
            d="M501.1,395.8c0,0-11.2,4.2-17.5,1.6l1.8,3C485.4,400.4,494.7,401.8,501.1,395.8z"
          />
          <path
            fill={colour0}
            d="M497.3,389.4c0,0-9.7,6.6-16.6,5.5l2.6,2.5C483.3,397.4,492.8,396.6,497.3,389.4z"
          />
          <path
            fill={colour0}
            d="M493.4,384.9c0,0-9.1,7.3-16.1,6.7l2.8,2.3C480.1,393.8,489.5,392.4,493.4,384.9z"
          />
          <path
            fill={colour0}
            d="M487.7,380c0,0-8.5,7.9-15.5,7.8l3,2C475.2,389.9,484.5,387.8,487.7,380z"
          />
          <path
            fill={colour0}
            d="M480.7,375.3c0,0-4.3,8-9.9,7.9l2.9,2C473.7,385.3,480.4,383.1,480.7,375.3z"
          />
        </g>
        <g>
          <g>
            <path
              fill={colour0}
              d="M321.8,402.5c-2.8,0.4-18.8,5.2-18,4.6c5.7-4.2,4.5-9.7,6.4-12.4c4-5.5,7.2-6.2,7.2-6.2L321.8,402.5z"
            />
            <path
              fill={colour1}
              opacity={0.5}
              d="M371.1,400.4c2.4-1.8,11.6-9.1,11.4-10.1c-0.2-1-17.8-15.4-17.8-15.4L371.1,400.4z"
            />
            <path
              fill={colour1}
              opacity={0.5}
              d="M370.1,381.3c-6.6-15.3-24.6-23.6-38.3-18c-13.7,5.6-19.5,22.6-12.9,38c6.6,15.3,23.1,23.1,36.8,17.5
				C369.5,413.1,376.7,396.6,370.1,381.3z"
            />
            <path
              fill={colour2}
              d="M366.5,381.7c-6.4-14.8-21.8-22.6-34.3-17.4c-12.6,5.2-17.5,21.3-11.2,36.1c6.4,14.8,20.6,20,33.2,14.9
				C366.8,410.1,372.9,396.5,366.5,381.7z"
            />
            <path
              fill={colour3}
              d="M354,411.3c-12.6,5.2-27.1-0.8-33.5-15.6c-1-2.4-1.8-4.8-2.2-7.2c0.2,3.9,1,7.9,2.7,11.9
				c6.4,14.8,21,20.7,33.5,15.6c10.7-4.4,16.4-15.4,14-27.7C368.9,398.7,363.3,407.5,354,411.3z"
            />
            <path
              fill={colour4}
              d="M353.5,382.8c-2.9-5.7-9.6-8.3-15-5.7c-5.3,2.6-7.3,9.4-4.4,15.1c2.9,5.7,9.6,8.3,14.9,5.7
				C354.5,395.4,356.4,388.6,353.5,382.8z"
            />
            <path
              fill={colour5}
              opacity={0.5}
              d="M373.2,385.6c-11.7-10.9-24.6-26.5-38.6-20.7c-12.5,5.2-24,22.3-20.8,35.7
				C327.7,387.9,354.3,379.7,373.2,385.6z"
            />
            <path
              fill={colour2}
              d="M354.4,394.9c1.2-2,0.9-4.4-0.6-5.4c-1.5-0.9-3.7,0-4.9,2c-1.2,2-0.9,4.4,0.6,5.4
				C351,397.8,353.2,396.9,354.4,394.9z"
            />
            <path
              fill={colour2}
              d="M352.5,387.8c0.5-0.5,0.7-1.4,0.3-2.1c-0.4-0.7-1.1-0.8-1.6-0.3c-0.5,0.5-0.7,1.4-0.3,2.1
				C351.2,388.1,351.9,388.3,352.5,387.8z"
            />
            <path
              fill={colour6}
              d="M313.4,397.7c-0.2-7.6,24.1-35.3,59.1-20.6c0,0-16.4-25.2-39.9-15.5C305.3,372.8,313.4,397.7,313.4,397.7z"
            />
            <path
              fill={colour6}
              d="M311.8,395c0.7,3.5,1.3,5.1,1.3,5.1c-0.3-7.9,21.3-33.4,66.3-13.8c0,0-5.9-7.8-7.6-10.4
				C339.5,364.3,316.6,384.4,311.8,395z"
            />
          </g>
          <path
            fill={colour0}
            d="M382.1,390.6c-7.8-3-20.4-14.9-41.7-8.3c-21.3,6.6-27.7,17.8-28.6,22c0,0-4-1.3-2.5-7.4
			c1.6-6.1,13.8-18.7,30.9-20.6c20.2-2.3,31,8.9,51.5,13.8L382.1,390.6z"
          />
          <path
            fill={colour6}
            d="M320.9,407.2c0,0,4.9,15.8,26,14.4c16.2-1,29.9-20.1,32-28.8c0,0-19.2,17.6-36.1,17
			C325.9,409.3,320.9,407.2,320.9,407.2z"
          />
          <path
            fill={colour0}
            d="M389.7,390c-17.1,2.2-25,26.1-50,23.7c-25-2.4-19.6-7.9-38.9-4.7c0,0,11.6-7.9,20.1-5.8
			c8.5,2.1,22.1,7.4,34.6,3.9C365.2,404.4,378.4,385.6,389.7,390z"
          />
          <path
            fill={colour0}
            d="M294.1,395.8c0,0,11.2,4.2,17.5,1.6l-1.8,3C309.8,400.4,300.4,401.8,294.1,395.8z"
          />
          <path
            fill={colour0}
            d="M297.8,389.4c0,0,9.7,6.6,16.6,5.5l-2.6,2.5C311.8,397.4,302.3,396.6,297.8,389.4z"
          />
          <path
            fill={colour0}
            d="M301.7,384.9c0,0,9.1,7.3,16.1,6.7l-2.8,2.3C315,393.8,305.6,392.4,301.7,384.9z"
          />
          <path
            fill={colour0}
            d="M307.4,380c0,0,8.5,7.9,15.5,7.8l-3,2C319.9,389.9,310.7,387.8,307.4,380z"
          />
          <path
            fill={colour0}
            d="M314.5,375.3c0,0,4.3,8,9.9,7.9l-2.9,2C321.4,385.3,314.7,383.1,314.5,375.3z"
          />
        </g>
      </g>
    </>
  );
};

export default Eyes_8;
